export const brandName = "UO Addicts";
export const brandUrl = "UOAddicts.com";
export const brandSlug = "uo-addicts";
export const brandMetaImage = "https://uoaddicts.com/images/uoaddicts.png";
export const brandDescription = `UOAddicts.com is provided by Jaseowns and aims to be a collaboration of UO resources by the players for the players.`;
export const brandLogo = "/favicons/apple-touch-icon.png";
export const brandLogoAlt = "UO Addicts social media image";
export const brandCreator = "@jaseowns";


// export const brandName = "UO Razor Scripts";
// export const brandUrl = "UO Razor Scripts";
// export const brandSlug = "uo-razor-scripts";
// export const brandDescription = `UORazorScripts.com is provided by Jaseowns and aims to be a collaboration of UO Razor Scripts by the players for the players.`;
// export const brandLogo = "/favicons/apple-touch-icon.png";
// export const brandLogoAlt = "UO Razor Script social media image";